import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import AccountButtons from '../../../sections/Confirmation/AccountButtons/AccountButtons';
import Language from '../../../v2/lang/language';
import {isMobile} from '../../../v2/selectors/DeviceSelectors';
import {getOrderNumber, getSettings, getSiteDataV2} from '../../../v2/selectors/selectors';
import MediaQueries from '../../../v2/style-helper/MediaQueries';
import AdvertisementLazyLoader from '../Advertisment/AdvertisementLazyLoader';
import RewardsEarntMessage from '../LoyaltyPointsEarntMessage/LoyaltyPointsEarntMessage';
import {OrderNumber} from '../OrderNumber/OrderNumber';

const useStyles = createUseStyles({
  completePageNextSteps: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  innerContainer: {
    width: '100%',
    [MediaQueries.phone]: {
      maxWidth: 400,
    },
  },
});

export function CompletePageNextSteps(props) {
  const classes = useStyles();
  const getOrderNumberLine = () => ({
    // eslint-disable-next-line no-restricted-properties
    __html: Language.getText('checkout.complete.intro.order.number.text')
      .replace('{0}', props.orderNumber),
  });
  
  return (
    <div className={classes.completePageNextSteps}>
      <div className={classes.innerContainer}>
        <RewardsEarntMessage />
        {props.useNewOrderNumberKey ? (
          <OrderNumber orderNumber={props.orderNumber} siteCode={props.siteCode} />
        ) : (
          <p dangerouslySetInnerHTML={getOrderNumberLine()} />
        )}
        <AccountButtons prefixName="CompletePageNextSteps" />
        
        {!props.isMobile && props.advertisementLayout && (
          <AdvertisementLazyLoader />
        )}
      </div>
    </div>
  );
}

CompletePageNextSteps.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  siteCode: PropTypes.string.isRequired,
  useNewOrderNumberKey: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  advertisementLayout: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  orderNumber: getOrderNumber(state),
  siteCode: getSiteDataV2(state)?.siteCode,
  useNewOrderNumberKey: !!getSettings(state)?.use_new_order_number_property,
  isMobile: isMobile(state),
  advertisementLayout: getSettings(state)?.checkout_complete_ad,
});

export default connect(
  mapStateToProps,
)(CompletePageNextSteps);
